/*= ========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */


import state from './moduleMasterState.js';
import mutations from './moduleMasterMutations.js';
import actions from './moduleMasterActions.js';
import getters from './moduleMasterGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
